import { useQuery } from 'react-query';
import api from 'services';
import type { ApiError } from 'services/api.errors';
import type { ContributionDetailsResponse, ID } from 'services/requests';
import { CommonCustomError } from 'types/errors';
import { useQueryParams } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import { Parameters } from 'constants/queryParameters';
import type { AxiosError } from 'axios';
import { useGetAllAssets } from '../portfolio';

export const useGetContributionDetails = () => {
  const { isSuccess, data: allAssets } = useGetAllAssets();

  const id = useQueryParams(Parameters.contributionId);
  const queryKey = [QueryKeys.contributionDetails, id];

  const queryFn = (id: ID | undefined) => async () => {
    if (!allAssets) {
      throw new CommonCustomError();
    }

    const { data } = await api.getContributionDetails(id);

    const items = data.items.map((dataItem) => {
      const assetInfo = allAssets[dataItem.asset.id];
      if (!assetInfo) {
        throw new CommonCustomError();
      }

      return {
        ...dataItem,
        asset: { ...assetInfo, amount: dataItem.asset.amount },
      };
    });

    return {
      items,
    };
  };

  return useQuery<ContributionDetailsResponse, AxiosError<ApiError, string>>(
    queryKey,
    queryFn(id),
    {
      enabled: Boolean(id) && isSuccess,
      retry: 1,
    },
  );
};
